import { Outlet } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import {
  FinanceSalesModuleRoutesVisibilityDocument,
  FinanceSalesModuleRoutesVisibilityQuery,
} from 'generated/resources/graphql'

import { AccountsPayableUpsellModal } from 'modules/finance/components/AccountsPayableUpsellModal'
import CollectionsBootstrap from 'modules/finance/lib/CollectionsBootstrap'
import { FrequencyContextProvider } from 'modules/payroll_bundle/lib/frequencyContext'

export interface SalesRootPageOutletContext {
  routesVisibility: FinanceSalesModuleRoutesVisibilityQuery
}

const SalesRootPage = () => {
  const { data, error, loading } = useQuery(FinanceSalesModuleRoutesVisibilityDocument)

  if (error || loading) {
    return null
  }
  return (
    <CollectionsBootstrap>
      <FrequencyContextProvider>
        <AccountsPayableUpsellModal source="ap_finance_upsellcard"></AccountsPayableUpsellModal>
        <Outlet context={{ routesVisibility: data }} />
      </FrequencyContextProvider>
    </CollectionsBootstrap>
  )
}

export default SalesRootPage
